var React = require('react');

function LinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.1003 0.833374V2.31486H11.7596L4.47807 9.59634L5.52252 10.6408L12.804 3.3593V6.01856H14.2855V0.833374H9.1003ZM12.804 12.6852H2.43363V2.31486H7.61881V0.833374H2.43363C1.61141 0.833374 0.952148 1.50004 0.952148 2.31486V12.6852C0.952148 13.0781 1.10823 13.455 1.38606 13.7328C1.6639 14.0106 2.04072 14.1667 2.43363 14.1667H12.804C13.1969 14.1667 13.5737 14.0106 13.8516 13.7328C14.1294 13.455 14.2855 13.0781 14.2855 12.6852V7.50004H12.804V12.6852Z","fill":"currentColor"}));
}

LinkInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 15 15","fill":"none"};

module.exports = LinkInline;

LinkInline.default = LinkInline;
